import { combineReducers } from "@reduxjs/toolkit";
import storage from "reduxjs-toolkit-persist/lib/storage";
// slices
// import homeReducer from "./slices/home";
// import movieReducer from "./slices/movie";
// import tvshowReducer from "./slices/tvshow";
import myListReducer from "./slices/myList";
// import producerReducer from "./slices/producer";
// import detailReducer from "./slices/detail";
// import seasonReducer from "./slices/season";
// import episodeReducer from "./slices/episode";
import filterReducer from "./slices/filter";

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "afrikast-redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  // home: homeReducer,
  // movie: movieReducer,
  // tvshow: tvshowReducer,
  myList: myListReducer,
  // producer: producerReducer,
  // detail: detailReducer,
  // season: seasonReducer,
  // episode: episodeReducer,
  filter: filterReducer,
});

export { rootPersistConfig, rootReducer };
